import ApiConnector from "@/repository/connector";

class RecordParams {
  async get() {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/record-params/cars/`,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
  async getTires(slug) {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.get(
      `/v1/record-params/cars/${slug}/tires/`,
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  }
}

export default new RecordParams();
